import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import NavBarMenu from "@/modules/vue/components/NavBarMenu.vue";
import NavBarMenuItem from "@/modules/vue/components/NavBarMenuItem.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalSearchLayout',
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(DefaultInGameLayout, {
        back: ""
      }, {
        title: _withCtx(() => [_renderSlot(_ctx.$slots, "title")]),
        submenu: _withCtx(() => [_createVNode(NavBarMenu, null, {
          default: _withCtx(() => [_createVNode(NavBarMenuItem, {
            to: {
              name: 'global-players.index',
              params: _ctx.$route.params
            },
            icon: _ctx.IconEnum.People20Regular,
            label: _ctx.$t('players')
          }, null, 8, ["to", "icon", "label"]), _createVNode(NavBarMenuItem, {
            to: {
              name: 'global-teams.index',
              params: _ctx.$route.params
            },
            icon: _ctx.IconEnum.PeopleCommunity20Regular,
            label: _ctx.$t('teams')
          }, null, 8, ["to", "icon", "label"])]),
          _: 1
        })]),
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
        _: 3
      });
    };
  }
});